<div class="d-flex justify-content-between mt-3 mb-3 gap-4" style="height:400px">
  <div class="col">
    <div class="card p-3 h-100">
      <!-- <div class="d-flex justify-content-between">
        <h3 class="card-title fw-bold text-muted">Skills</h3>
        <mat-chip-grid>
          <mat-chip color="primary" selected>All</mat-chip>
          <mat-chip>Industry Knowledge</mat-chip>
          <mat-chip>Tools & Technolgies</mat-chip>
        </mat-chip-grid>
      </div> -->

      <ngx-simplebar style="max-height: 100%; overflow-y: scroll; overflow-x: hidden; scrollbar-width: none;" class="ms-2 mt-2">

        <div class="mb-4" *ngIf="this.contact?.purchasedData?.profile_data?.profile_expertises && this.contact?.purchasedData?.profile_data?.profile_expertises.length > 0 ">
          <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">hub</mat-icon> <span><b>Skills</b></span></div>
          <div class="mb-2"></div>
          <mat-chip-grid class="mt-2">
            <mat-chip color="primary" selected (click)="toggleShowAll()">
              <small>{{ showAll ? 'Show Less' : 'Show All' }}</small>
            </mat-chip>
            <mat-chip *ngFor="let item of displayedItems">
              <small>{{item}}</small>
            </mat-chip>
          </mat-chip-grid>
        </div>
        <div *ngIf="this.contact?.purchasedData?.resume_data?.educations">
          <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">school</mat-icon><span><b>Education</b></span></div>
          <ul class="list-group list-group-flush mb-2">
            <li *ngFor="let item of this.contact?.purchasedData?.resume_data?.educations"  class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">

                <div class="d-flex">
                  <!-- <clearbit-logo height="27" width="27" [domain]="item?.educational_establishment_web_address"></clearbit-logo> -->
                  <div class="d-flex flex-column">
                    <small class="fw-bolder">
                      <a *ngIf="item?.educational_establishment_web_address?.url" [href]="item?.educational_establishment_web_address?.url" target="_blank" class="text-decoration-none text-muted">{{item?.educational_establishment_name}}</a>
                       <span *ngIf="item?.educational_establishment_web_address?.url == null">{{item?.educational_establishment}}</span>
                    </small>
                    <small class="text-muted"><span *ngIf="item?.diploma">{{item?.diploma +','}}</span> <span *ngIf="item?.specialization">{{item?.specialization}}</span></small>
                    <small class="text-muted" *ngIf="item?.start_date || item?.end_date">{{item?.start_date |  date:'mediumDate'}} - {{item?.end_date |  date:'mediumDate'}}</small>
                  </div>
                  </div>
             </li>
          </ul>
        </div>
        <div *ngIf="this.contact?.purchasedData?.resume_data?.certifications">
          <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">description</mat-icon><span><b>Certifications</b></span></div>
          <ul class="list-group list-group-flush mb-2">
            <li *ngFor="let item of this.contact?.purchasedData?.resume_data?.certifications" class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">
              <div class="d-flex flex-column">
                <small class="fw-bolder">{{item?.name}}</small>
                <small class="text-muted"><span *ngIf="item?.authority">Authority: {{item?.authority}}</span></small>
                <small class="text-muted"><span *ngIf="item?.reference">Reference: {{item?.reference}}</span></small>
              </div>
            </li>
          </ul>
        </div>
        <div *ngIf="this.contact?.purchasedData?.resume_data?.awards">
          <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">workspace_premium</mat-icon><span><b>Awards</b></span></div>
        <ul class="list-group list-group-flush mb-2">
          <li *ngFor="let item of this.contact?.purchasedData?.resume_data?.awards" class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">
            <div class="d-flex flex-column">
              <small class="fw-bolder">{{item?.name}}</small>
              <small class="text-muted">
                <span *ngIf="item?.description" [innerHTML]="item?.description | linkify"></span>
              </small>
              <small class="text-muted" *ngIf="item?.date">{{item?.date |  date:'mediumDate'}}</small>
            </div>
          </li>
        </ul>
      </div>
      <div *ngIf="this.contact?.purchasedData?.resume_data?.memberships">
        <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">card_membership</mat-icon><span><b>Memberships</b></span></div>
      <ul class="list-group list-group-flush mb-2">
        <li *ngFor="let item of this.contact?.purchasedData?.resume_data?.memberships" class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">
          <div class="d-flex flex-column">
            <small class="fw-bolder">{{item?.name}}</small>
            <small class="text-muted"><span *ngIf="item?.title">{{item?.title}}</span></small>
            <small class="text-muted" *ngIf="item?.end_date">{{item?.end_date |  date:'mediumDate'}}</small>
          </div>
        </li>
      </ul>
    </div>
      <div *ngIf="this.contact?.purchasedData?.resume_data?.patents">
        <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">article</mat-icon><span><b>Patents</b></span></div>
      <ul class="list-group list-group-flush mb-2">
        <li *ngFor="let item of this.contact?.purchasedData?.resume_data?.patents" class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">
          <div class="d-flex flex-column">
            <small class="fw-bolder">{{item?.name}}</small>
            <small class="text-muted">
              <span *ngIf="item?.issue" [innerHTML]="item?.issue | linkify"></span>
              <span *ngIf="item?.number">{{item?.number}}</span>
            </small>
            <small class="text-muted" *ngIf="item?.date">{{item?.date |  date:'mediumDate'}}</small>
          </div>
        </li>
      </ul>
    </div>
    <div *ngIf="this.contact?.purchasedData?.resume_data?.publications">
      <div class="d-flex justify-content-start align-items-center"><mat-icon class="me-2 text-muted">newspaper</mat-icon><span><b>Publications</b></span></div>
      <ul class="list-group list-group-flush mb-2">
        <li *ngFor="let item of this.contact?.purchasedData?.resume_data?.publications"  class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">

            <div class="d-flex">
              <!-- <clearbit-logo height="27" width="27" [domain]="item?.educational_establishment_web_address"></clearbit-logo> -->
              <div class="d-flex flex-column">
                <small class="fw-bolder"><a [href]="item?.web_address?.url" target="_blank">{{item?.name}}</a></small>
                <small class="text-muted">
                  <span *ngIf="item?.description" [innerHTML]="item?.description | linkify"></span>
                </small>
                <small class="text-muted"><span *ngIf="item?.issue">{{item?.issue }}</span> </small>
                <small class="text-muted" *ngIf="item?.date">{{item?.date |  date:'mediumDate'}} </small>
              </div>
              </div>
         </li>
      </ul>
    </div>
    <div *ngIf="this.contact?.purchasedData?.profile_data?.profile_languages.length > 0">
      <div class="d-flex justify-content-start align-items-center"><mat-icon
          class="me-2 text-muted">languages</mat-icon><span><b>Languages</b></span></div>
          <div class="d-flex mt-2 ms-3">
              <small class="fw-bolder text-muted">{{this.contact?.purchasedData?.profile_data?.profile_languages?.join(', ')}}</small>
          </div>
      <!-- <ul class="list-group list-group-flush mb-2">
        <li *ngFor="let item of this.contact?.purchasedData?.profile_data?.profile_languages"
          class="list-group-item d-flex justify-content-start align-items-start text-capitalize data-item text-muted">
          <div class="d-flex">
            <div class="d-flex flex-column">
              <small class="fw-bolder">{{item}}</small>
            </div>
          </div>
        </li>
      </ul> -->
    </div>

      </ngx-simplebar>
    </div>

  </div>
  <div class="col">

    <div class="card p-3 h-100">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center" *ngIf="isLoading">
        <mat-spinner  [diameter]="50" [strokeWidth]="2"></mat-spinner>
      </div>
      <div *ngIf="!isLoading" echarts [options]="chartOption" class="demo-chart"></div>
  </div>
  </div>
</div>
